type LogLevel = 'info' | 'warn' | 'error' | 'debug';

class LoggerService {
    private isDev = import.meta.env.DEV;

    private formatMessage(level: LogLevel, message: string, context?: any) {
        const timestamp = new Date().toISOString();
        return {
            timestamp,
            level,
            message,
            context,
        };
    }

    public info(message: string, context?: any) {
        if (this.isDev) {
            const formatted = this.formatMessage('info', message, context);
            console.log(`[INFO] ${formatted.timestamp} ${message}`, context || '');
        }
        // In production, you might send this to a logging service
    }

    public warn(message: string, context?: any) {
        if (this.isDev) {
            const formatted = this.formatMessage('warn', message, context);
            console.warn(`[WARN] ${formatted.timestamp} ${message}`, context || '');
        }
    }

    public error(message: string, error?: any, context?: any) {
        if (this.isDev) {
            const formatted = this.formatMessage('error', message, { ...context, error });
            console.error(`[ERROR] ${formatted.timestamp} ${message}`, error || '', context || '');
        }
    }

    public debug(message: string, context?: any) {
        if (this.isDev) {
            const formatted = this.formatMessage('debug', message, context);
            console.debug(`[DEBUG] ${formatted.timestamp} ${message}`, context || '');
        }
    }
}

export const logger = new LoggerService();
